import { Spinner, Skeleton, EmptyState } from '../../components/ui';
import BotonOpcion from './BotonOpcion';
import './Buscar.css';

const IconPersona = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
);

export default function ListaMedicos({ cargando, medicos, termino, onElegir }) {
  if (cargando) {
    return (
      <div className="buscar-list" aria-busy="true">
        <Spinner label="Buscando médicos…" />
        {[0, 1].map((i) => (
          <div key={i} className="buscar-choice" style={{ cursor: 'default' }}>
            <Skeleton width="52px" height="52px" radius="14px" />
            <div style={{ flex: 1 }}><Skeleton width="40%" /><div style={{ height: 8 }} /><Skeleton width="70%" /></div>
          </div>
        ))}
      </div>
    );
  }

  if (!medicos) return null;

  if (medicos.length === 0) {
    return <EmptyState title={`No encontramos médicos para "${termino}".`} />;
  }

  return (
    <>
      <p className="buscar-muted">{medicos.length} resultado{medicos.length === 1 ? '' : 's'}</p>
      <div className="buscar-list" role="list">
        {medicos.map((m) => (
          <BotonOpcion
            key={m.id}
            role="listitem"
            icono={<IconPersona />}
            titulo={`${m.nombre} ${m.apellido}`}
            descripcion={m.servicios?.length > 0 ? m.servicios.map((s) => s.nombre).join(' · ') : null}
            extra={<span aria-hidden="true">→</span>}
            onClick={() => onElegir(m)}
          />
        ))}
      </div>
    </>
  );
}